export default {
  routes: [
    /*  登录页 */
    {
      path: "/",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/login/index.vue"),
    },
    /* 管理端 */
    {
      path: "/management",
      name: "Management",
      component: () => import("@/view/management/index.vue"), //导航
      // redirect: "/management/supAdmin", //重定向到第一个子路由
      children: [
        /* 首页-数据面板 */
        //  {
        //   path: "dataChart",
        //   name: "DataChart",
        //   component: () => import("@/view/management/dataChart/index.vue"),
        // },

        /* 欢迎页*/
        {
          path: "welcome",
          name: "Welcome",
          component: () => import("@/view/management/welcome/index.vue"),
        },

        /* 系统管理 */
        {
          path: "system",
          component: () =>
            import("@/view/management/system/index.vue"), //导航
          children: [{
              path: "user",
              name: "SysUser",
              component: () =>
                import("@/view/management/system/user/index.vue"),
            },
            {
              path: "authGroup",
              name: "AuthGroup",
              component: () =>
                import(
                  "@/view/management/system/authGroup/index.vue"
                ),
            },
            {
              path: "menu",
              name: "Menu",
              component: () =>
                import("@/view/management/system/menu/index.vue"),
            },
            {
              path: "log",
              name: "Log",
              component: () =>
                import("@/view/management/system/log/index.vue"),
            },
          ],
        },


        /* 企业管理 */
        {
          path: "fairAdmin",
          name: "FairAdmin",
          component: () => import("@/view/management/fairAdmin/index.vue"), //导航
          children: [
            /* crm */
            {
              path: "crm",
              name: "Crm",
              component: () =>
                import("@/view/management/fairAdmin/crm/index.vue"),
            },

            /* 食品展 */
            {
              path: "foodExpo",
              name: "FoodExpo",
              component: () =>
                import("@/view/management/fairAdmin/foodExpo/index.vue"),
            },

            /* 茶博会相关数据 */
            {
              path: "teaData",
              component: () =>
                import("@/view/management/fairAdmin/teaData/index.vue"), //导航
              children: [{
                  path: "bookingBooth",
                  name: "BookingBooth",
                  component: () =>
                    import("@/view/management/fairAdmin/teaData/BookingBooth.vue"),
                },
                {
                  path: "miniRegister",
                  name: "MiniRegister",
                  component: () =>
                    import("@/view/management/fairAdmin/teaData/MiniRegister.vue"),
                },
                {
                  path: "miniVip",
                  name: "MiniVip",
                  component: () =>
                    import("@/view/management/fairAdmin/teaData/MiniVip.vue"),
                },
                {
                  path: "bookingHotel",
                  name: "BookingHotel",
                  component: () =>
                    import("@/view/management/fairAdmin/teaData/BookingHotel.vue"),
                },
                {
                  path: "ptRegister",
                  name: "PtRegister",
                  component: () =>
                    import("@/view/management/fairAdmin/teaData/PtRegister.vue"),
                },
                {
                  path: "ptRegister",
                  name: "PtRegister",
                  component: () =>
                    import("@/view/management/fairAdmin/teaData/PtRegister.vue"),
                },

                {
                  path: "requestPtStuff",
                  name: "RequestPtStuff",
                  component: () =>
                    import("@/view/management/fairAdmin/teaData/RequestPtStuff.vue"),
                },
              ],
            },
          ],
        },

        /* 小程序管理 */
        {
          path: "miniApp",
          component: () => import("@/view/management/miniApp/index.vue"), //导航
          children: [{
              path: "user",
              name: "MallUser",
              component: () =>
                import("@/view/management/miniApp/user/index.vue"),
            },
            {
              path: "store",
              name: "MallStore",
              component: () =>
                import("@/view/management/miniApp/store/index.vue"),
            }, {
              path: "banner",
              name: "MiniAppBanner",
              component: () =>
                import("@/view/management/miniApp/banner/index.vue"),
            },
            {
              path: "article",
              name: "MiniAppArticle",
              component: () =>
                import("@/view/management/miniApp/article/index.vue"),
            }
          ]
        },

        /* 门店管理 */
        {
          path: "store",
          name: "Store",
          component: () => import("@/view/management/store/index.vue"),
          children: [{
              path: "storeList",
              name: "StoreList",
              component: () =>
                import("@/view/management/store/storeList/index.vue"),
            },
            {
              path: "staff",
              name: "Staff",
              component: () =>
                import("@/view/management/store/staff/index.vue"),
            },
            {
              path: "coupon",
              name: "Coupon",
              component: () =>
                import("@/view/management/store/coupon/index.vue"),
            },
            {
              path: "goods",
              name: "Goods",
              component: () =>
                import("@/view/management/store/goods/index.vue"),
              children: [{
                  path: "goodsKind",
                  name: "GoodsKind",
                  component: () =>
                    import("@/view/management/store/goods/goodsKind/index.vue"),
                },
                {
                  path: "goodsList",
                  name: "GoodsList",
                  component: () =>
                    import("@/view/management/store/goods/goodsList/index.vue"),
                },
              ],
            },
            {
              path: "mallGoods",
              name: "MallGoods",
              component: () =>
                import("@/view/management/store/mallGoods/index.vue"),
              children: [{
                  path: "goodsKind",
                  name: "MallGoodsKind",
                  component: () =>
                    import(
                      "@/view/management/store/mallGoods/goodsKind/index.vue"
                    ),
                },
                {
                  path: "goodsList",
                  name: "MallGoodsList",
                  component: () =>
                    import(
                      "@/view/management/store/mallGoods/goodsList/index.vue"
                    ),
                },
              ],
            },
            {
              path: "integralGoods",
              name: "IntegralGoods",
              component: () =>
                import("@/view/management/store/integralGoods/index.vue"),
              children: [{
                  path: "goodsKind",
                  name: "IntegralGoodsKind",
                  component: () =>
                    import(
                      "@/view/management/store/integralGoods/goodsKind/index.vue"
                    ),
                },
                {
                  path: "goodsList",
                  name: "IntegralGoodsList",
                  component: () =>
                    import(
                      "@/view/management/store/integralGoods/goodsList/index.vue"
                    ),
                },
              ],
            },
            /* 会员管理 */
            {
              path: "vipCard",
              name: "MallVipCard",
              component: () => import("@/view/management/store/vipCard"),
              children: [{
                  path: "vipCardList",
                  name: "MallVipCardList",
                  component: () => import("@/view/management/store/vipCard/vipCardList"),
                },
                {
                  path: "vipCardRecode",
                  name: "MallVipCardRecode",
                  component: () =>
                    import("@/view/management/store/vipCard/vipCardRecode"),
                },
              ],
            },

            /* 门店会员订单 */
            {
              path: "order",
              name: "Order",
              component: () => import("@/view/management/store/order/index.vue"),
            },

          ],
        },



        /* 个人页 */
        {
          path: "person",
          // name: "Person",
          component: () => import("@/view/management/person/index.vue"), //导航
          children: [{
            path: "center",
            name: "PersonCenter",
            component: () =>
              import("@/view/management/person/center/index.vue"),
          }, ],
        },
        /* 废弃超级管理员 */
        {
          path: "supAdmin",
          name: "SupAdmin",
          component: () => import("@/view/management/supAdmin/index.vue"), //导航
          children: [

            {
              path: "mall",
              name: "Mall",
              component: () =>
                import("@/view/management/supAdmin/mall/index.vue"),
              children: [
                // {
                //   path: "order",
                //   name: "MallOrder",
                //   component: () =>
                //     import("@/view/management/supAdmin/mall/order/index.vue"),
                // },
                {
                  path: "admin",
                  name: "MallAdmin",
                  component: () =>
                    import("@/view/management/supAdmin/mall/admin/index.vue"),
                },
              ],
            }
          ],
        },
        /* 废弃老的权限 */
        {
          path: "permission",
          name: "Permission",
          component: () => import("@/view/management/permission/index.vue"), //导航
          children: [{
              path: "admin",
              name: "PermissionAdmin",
              component: () =>
                import("@/view/management/permission/admin/index.vue"),
            },
            {
              path: "role",
              name: "PermissionRole",
              component: () =>
                import("@/view/management/permission/role/index.vue"),
            },
          ],
        },
        /* 废弃商家服务 */
        {
          path: "merchant",
          name: "Merchant",
          component: () => import("@/view/management/merchant/index.vue"),
          children: [{
            path: "payment",
            name: "Payment",
            component: () =>
              import("@/view/management/merchant/payment/index.vue"),
          }, ],
        },
      ],
    },
    /* 其他页 */
    {
      path: "/errow",
      name: "Errow",
      component: () => import("@/view/error/index.vue"),
    },
  ],
  // mode: "history",
  mode: "hash",
};